/** Current UI language from localStorage (`en` | `ar`). */
export function getAppLanguage() {
  return localStorage.getItem("language") === "en" ? "en" : "ar"
}
